"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_i18next_1 = require("react-i18next");
const PrintOutClassification = (0, react_1.forwardRef)(({ data }, ref) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(react_bootstrap_1.Container, { className: 'p-4', ref: ref },
        (data === null || data === void 0 ? void 0 : data.inst_title) ? (react_1.default.createElement("h3", { className: "s30 preto mb-2" }, data.inst_title)) : '',
        (data === null || data === void 0 ? void 0 : data.title) ? (react_1.default.createElement(react_bootstrap_1.Row, { className: "s24 preto" },
            react_1.default.createElement(react_bootstrap_1.Col, { className: 'font-weight-bold', xs: '3' },
                t('Titulo'),
                ":"),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: '9' }, data === null || data === void 0 ? void 0 : data.title))) : '',
        (data === null || data === void 0 ? void 0 : data.author) ? (react_1.default.createElement(react_bootstrap_1.Row, { className: "s24 preto" },
            react_1.default.createElement(react_bootstrap_1.Col, { className: 'font-weight-bold', xs: '3' },
                t('Author'),
                ":"),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: '9' }, data.author))) : '',
        (data === null || data === void 0 ? void 0 : data.classification) ? (react_1.default.createElement(react_bootstrap_1.Row, { className: "s24 preto" },
            react_1.default.createElement(react_bootstrap_1.Col, { className: 'font-weight-bold', xs: '3' },
                t('Classificacao'),
                ":"),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: '9' }, data.classification))) : '',
        (data === null || data === void 0 ? void 0 : data.article) ? (react_1.default.createElement(react_bootstrap_1.Row, { className: "s24 preto" },
            react_1.default.createElement(react_bootstrap_1.Col, { className: 'font-weight-bold', xs: '3' },
                t('Artigo'),
                ":"),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: '9' }, data.article))) : ''));
});
PrintOutClassification.displayName = 'PrintOutClassification';
exports.default = PrintOutClassification;
